import { useEffect, useRef } from 'react';
import { usePageState } from './usePageState';


export const CARD_PAGE_SIZE = 24;


export function pageCursor(page: number, limit = CARD_PAGE_SIZE): string | undefined {
  const safe = Math.max(0, page);
  return safe > 0 ? String(safe * limit) : undefined;
}


export function useListPage(resetKey: unknown, name: string | null = null) {
  const [page, setPage] = usePageState(name === null ? null : `${name}:page`, 0);
  const key = typeof resetKey === 'string' ? resetKey : JSON.stringify(resetKey);
  const previousKey = useRef(key);

  useEffect(() => {
    if (previousKey.current === key) return;
    previousKey.current = key;
    setPage(0);
  }, [key, setPage]);

  return {
    page,
    setPage,
    goPrev: () => setPage((current) => Math.max(0, current - 1)),
    goNext: () => setPage((current) => current + 1),
  };
}
